'use client';

import classNames from 'classnames';

import { useShallowRouting } from '@/utils/hooks/useShallowRouting';

export default function Sort({
  close,
  sort,
  setState,
  dataObj,
}: {
  close: () => void;
  sort: string;
  setState: (code: string) => void;
  dataObj: { code: string; title: string }[];
}) {
  const { setParam } = useShallowRouting();
  return (
    <>
      <ul className="type_list">
        {dataObj.map((obj) => (
          <li key={obj.code}>
            <button
              onClick={() => {
                close();
                setState(obj.code);
                setParam('sort', obj.code);
              }}
              className={classNames({ active: sort === obj.code })}
            >
              {obj.title}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
